export { default } from "./FontSizeSwitcher";